import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  useTheme,
  Fab,
  Stack,
  Icon,
  Paper,
  Button,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { RemMensaje } from "../../redux/actions/mensajes";
import {
  getCargando,
  getMensaje,
  getElementos,
  getGruposElementos,
} from "../../redux/selectors";
import { format as DateFormat } from "date-fns";
import {
  GetElementos,
  Solicitar,
  Recibir,
} from "../../redux/actions/elementos";
import SolicitarElementos from "./solicitarElementos";
import SwiperCard from "../../components/SwipperCard";
import Consulta from "./consulta";

const Elementos = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const paramIng = useParams();

  const [color, setColor] = React.useState({
    main: theme.palette.background.default,
    selected: "lightgray",
    pText: theme.palette.text.primary,
    sText: theme.palette.text.secondary,
    pText2: theme.palette.text.primary,
    sText2: theme.palette.text.secondary,
  });
  const { enqueueSnackbar /*, closeSnackbar*/ } = useSnackbar();
  const backdrop = useSelector((state) => getCargando(state));
  const mensaje = useSelector((state) => getMensaje(state));
  const listado = useSelector((state) => getElementos(state));
  const elementos = useSelector((state) => getGruposElementos(state));

  const [params, setParams] = React.useState(null);
  const [openSol, setOpenSol] = React.useState(false);
  const [openCons, setOpenCons] = React.useState(false);
  const [sol, setSol] = React.useState(null);

  React.useEffect(() => {
    if (mensaje.mensaje !== "") {
      enqueueSnackbar(mensaje.mensaje, {
        preventDuplicate: true,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: mensaje.variant,
        autoHideDuration: 3000,
      });
      dispatch(RemMensaje());
    }
  }, [mensaje]);

  React.useEffect(() => {
    if (paramIng.modo && paramIng.modo === "1") {
      document.body.style.backgroundColor = "#2f3035";
      setColor({
        main: "#2f3035",
        pText: "white",
        sText: "#ACACAC",
        selected: "black",
        pText2: color.pText,
        sText2: color.sText,
      });
    }
    const p = {
      Conductor: paramIng.conductor,
      Modo: paramIng.modo,
      Token: paramIng.token,
    };
    setParams(p);
    dispatch(GetElementos(p));
  }, []);

  return (
    <>
      <Stack
        sx={{
          p: 0,
          overflowY: "hidden",
          height: "100vh",
          maxHeight: "100vh",
        }}
      >
        <Backdrop
          sx={{
            zIndex: theme.zIndex.drawer + 1,
          }}
          open={backdrop}
        >
          <CircularProgress />
        </Backdrop>
        {!backdrop && listado && listado.length === 0 && (
          <Typography
            sx={{
              mt: 4,
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
            }}
            color="error"
          >
            No hay datos a mostrar.
          </Typography>
        )}

        {!backdrop && listado && listado.length > 0 && (
          <Stack
            sx={{
              overflow: "auto",
              height: "calc(100vh - 80px)",
              mt: 2,
            }}
          >
            <Stack spacing={2}>
              {listado.map((item) => (
                <SwiperCard
                  enabled={item.Estado < 2}
                  card={
                    <Paper
                      sx={{
                        backgroundColor:
                          item.Estado === 2 || item.Estado === 1
                            ? "lightgreen"
                            : item.Estado === 3
                              ? "#e37a7c"
                              : color.main,
                        border: "1px solid " + color.selected,
                        p: 1,
                      }}
                    >
                      <Stack
                        direction="row"
                        sx={{ width: "100%", alignItems: "center" }}
                      >
                        <Icon
                          sx={{
                            ml: 0.5,
                            mr: 2,
                            color: color.sText,
                          }}
                          fontSize="large"
                        >
                          {item.Estado === 1 || item.Estado === 2
                            ? "thumb_up"
                            : item.Estado === 3
                              ? "thumb_down"
                              : "label"}
                        </Icon>

                        <Stack sx={{ width: "100%" }}>
                          <Stack direction="row">
                            <Typography
                              variant="caption"
                              sx={{ color: color.pText }}
                              flexGrow={1}
                            >
                              {DateFormat(
                                new Date(item.Fecha),
                                "dd/MM/yyyy HH:mm",
                              )}
                            </Typography>
                            <Typography
                              fontSize="small"
                              fontStyle="italic"
                              variant="caption"
                              sx={{ lineBreak: "nowrap", color: color.sText }}
                            >
                              {item.Estado === 0
                                ? "Pendiente"
                                : item.Estado === 1
                                  ? "Entregado"
                                  : item.Estado === 2
                                    ? "Recibido"
                                    : "Cancelado"}
                            </Typography>
                          </Stack>
                          <Typography
                            variant="caption"
                            fontWeight="bold"
                            sx={{ lineBreak: "nowrap", color: color.pText }}
                          >
                            {item.Descripcion}
                          </Typography>
                          {item.Motivo && (
                            <Typography
                              variant="caption"
                              sx={{ color: color.sText, pl: 1 }}
                            >
                              {item.Motivo}
                            </Typography>
                          )}
                        </Stack>
                      </Stack>
                    </Paper>
                  }
                  wrapperStart={
                    <Stack
                      height="100%"
                      sx={{
                        backgroundColor: (theme) => theme.palette.primary.main,
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => {
                          setSol(item);
                          setOpenCons(true);
                        }}
                        size="small"
                        sx={{
                          backgroundColor: (theme) =>
                            theme.palette.primary.main,
                          height: "100%",
                        }}
                      >
                        Recibido
                      </Button>
                    </Stack>
                  }
                  wrapperEnd={null}
                />
              ))}
            </Stack>
          </Stack>
        )}
      </Stack>

      {!backdrop && (
        <Grid
          container
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            zIndex: 1002,
            margin: "5px",
          }}
          spacing={1}
        >
          <Grid size={12} sx={{ justifyContent: "end", display: "flex" }}>
            <Fab
              size="small"
              color="primary"
              sx={{ borderRadius: "20px" }}
              onClick={() => setOpenSol(true)}
              disabled={!elementos || elementos.length === 0}
            >
              <Icon>add</Icon>
            </Fab>
          </Grid>
          <Grid size={12} sx={{ height: "40px" }} />
        </Grid>
      )}

      {openSol && (
        <SolicitarElementos
          open={openSol || false}
          elementos={elementos || []}
          onClose={() => setOpenSol(false)}
          onSave={(v) => {
            dispatch(
              Solicitar({
                Elemento: v.elemento.Id,
                Motivo: v.motivo,
                Observacion: v.observaciones,
                Conductor: params.Conductor,
                Token: params.Token,
              }),
            );
            setOpenSol(false);
          }}
        />
      )}
      {openCons && Boolean(sol) && (
        <Consulta
          open={openCons || false}
          datos={sol}
          onClose={() => {
            setOpenCons(false);
            setSol(null);
          }}
          onSave={() => {
            dispatch(Recibir({ IdSolicitud: sol.Id, Token: params.token }));
            setOpenCons(false);
            setSol(null);
          }}
        />
      )}
    </>
  );
};

export default Elementos;
